// Сведения о съемке
import React from 'react';
import {
  CTable,
  CTableBody,
  CTableRow,
  CTableDataCell,
  CTableHeaderCell,
  CFormInput,
  CFormSelect
} from '@coreui/react';

const SurveyInfoTab = ({
  groupedData,
  goalMeasurementsOptions,
  normativeDocs,
  directionsOptions,
  pointsHeightOptions,
  measurementToolsOptions,
  measurementConductedByOptions,
  developedByOptions,
  selectedGoal,
  setSelectedGoal,
  selectedNormativeDoc,
  setSelectedNormativeDoc,
  selectedDirection,
  setSelectedDirection,
  selectedPointsHeight,
  setSelectedPointsHeight,
  selectedMeasurementTool,
  setSelectedMeasurementTool,
  selectedConductedBy,
  setSelectedConductedBy,
  selectedDevelopedBy,
  setSelectedDevelopedBy,
  dateMeasurement,
  setDateMeasurement,
  dateProtocol,
  setDateProtocol
}) => {


  const renderSelectRow = (label, options, selectedValue, onChangeHandler) => (
    <CTableRow key={`select-${label}`}>
      <CTableHeaderCell className="fw-bold text-start" style={{ width: "30%" }}>
        {label}
      </CTableHeaderCell>
      <CTableDataCell>
        <CFormSelect
          value={selectedValue}
          onChange={onChangeHandler}
          aria-label={label}
        >
          {options.length > 0 ? (
            options.map((opt, idx) => (
              <option key={idx} value={opt}>
                {opt}
              </option>
            ))
          ) : (
            <option value="">Нет данных</option>
          )}
        </CFormSelect>
      </CTableDataCell>
    </CTableRow>
  );

  return (
    <CTable borderless>
      <CTableBody>
        {/* Обычные поля */}
        {[
          "Объект",
          "Адрес объекта",
          "Основание для проведения измерений",
        ].map((key) => (
          <CTableRow key={`field-${key}`}>
            <CTableHeaderCell className="fw-bold text-start" style={{ width: "30%" }}>
              {key}
            </CTableHeaderCell>
            <CTableDataCell>
              <CFormInput type="text" value={groupedData[key] || ""} readOnly />
            </CTableDataCell>
          </CTableRow>
        ))}

        {/* Выпадающие списки */}
        {renderSelectRow(
          "Цель измерений",
          goalMeasurementsOptions,
          selectedGoal,
          (e) => setSelectedGoal(e.target.value)
        )}
        
        {normativeDocs.length > 0 && renderSelectRow(
          "Нормативные документы",
          normativeDocs,
          selectedNormativeDoc,
          (e) => setSelectedNormativeDoc(e.target.value)
        )}
        
        {renderSelectRow(
          "Расположение направлений стоянок",
          directionsOptions,
          selectedDirection,
          (e) => setSelectedDirection(e.target.value)
        )}
        
        {renderSelectRow(
          "Расположение точек съемки по высоте опоры",
          pointsHeightOptions,
          selectedPointsHeight,
          (e) => setSelectedPointsHeight(e.target.value)
        )}
        
        {renderSelectRow(
          "Средства измерений",
          measurementToolsOptions,
          selectedMeasurementTool,
          (e) => setSelectedMeasurementTool(e.target.value)
        )}
        
        {renderSelectRow(
          "Измерения проводил",
          measurementConductedByOptions,
          selectedConductedBy,
          (e) => setSelectedConductedBy(e.target.value)
        )}
        
        {renderSelectRow(
          "Разработал",
          developedByOptions,
          selectedDevelopedBy,
          (e) => setSelectedDevelopedBy(e.target.value)
        )}

        {/* Дата проведения измерений */}
        <CTableRow>
          <CTableHeaderCell className="fw-bold text-start" style={{ width: "30%" }}>
            Дата проведения измерений
          </CTableHeaderCell>
          <CTableDataCell>
            <CFormInput
              type="date"
              value={dateMeasurement || ""}
              onChange={(e) => setDateMeasurement(e.target.value)}
            />
          </CTableDataCell>
        </CTableRow>

        {/* Остальные поля */}
        {Object.entries(groupedData).map(([key, value]) => {
          if ([
            "Объект",
            "Адрес объекта",
            "Основание для проведения измерений",
            "Цель измерений",
            "Нормативные документы",
            "Расположение направлений стоянок",
            "Расположение точек съемки по высоте опоры",
            "Средства измерений",
            "Дата проведения измерений",
            "Дата протокола",
            "Измерения проводил",
            "Разработал"
          ].includes(key)) return null;

          if (key === "Расположение направлений стоянок:") {
            return (
              <CTableRow key={`other-${key}`}>
                <CTableHeaderCell className="fw-bold text-start" style={{ width: "30%" }}>
                  {key}
                </CTableHeaderCell>
                <CTableDataCell>
                  <CFormInput type="text" value={value || ""} readOnly />
                </CTableDataCell>
              </CTableRow>
            );
          }
          
          if (key === "Ширина основания, м") {
            return (
              <CTableRow key={`other-${key}`}>
                <CTableHeaderCell className="fw-bold text-start" style={{ width: "30%" }}>
                  {key}
                </CTableHeaderCell>
                <CTableDataCell>
                  <CFormInput
                    type="number"
                    value={value || ""}
                    readOnly
                    style={{ width: "150px" }}
                  />
                </CTableDataCell>
              </CTableRow>
            );
          }
          
          return (
            <CTableRow key={`other-${key}`}>
              <CTableHeaderCell className="fw-bold text-start" style={{ width: "30%" }}>
                {key}
              </CTableHeaderCell>
              <CTableDataCell>
                <CFormInput type="text" value={value || ""} readOnly />
              </CTableDataCell>
            </CTableRow>
          );
        })}

        {/* Дата протокола */}
        <CTableRow>
          <CTableHeaderCell className="fw-bold text-start" style={{ width: "30%" }}>
            Дата протокола
          </CTableHeaderCell>
          <CTableDataCell>
            <CFormInput
              type="date"
              value={dateProtocol || ""}
              onChange={(e) => setDateProtocol(e.target.value)}
            />
          </CTableDataCell>
        </CTableRow>
      </CTableBody>
    </CTable>
  );
};

export default SurveyInfoTab;